import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Store } from '@ngrx/store';
import { Options } from 'ng5-slider/options';
import { addSelectedFilter, removeSelectedFilter, togglShowSideFilter } from 'src/app/actions';
import { selectedFiltersSelector } from 'src/app/selectors';
import { Filter, TreeNode, FilterType, NodeType, FilterLogicaOperator, FilterIdExtractor, FilterComparisonOperator, FilterKey } from '../../models';


@Component({
  selector: 'tree-menu',
  templateUrl: './tree-menu.component.html',
  styleUrls: ['./tree-menu.component.css']
})
export class TreeMenuComponent implements OnInit {

  constructor(private store: Store) { }

  @Input('data') set _data(schema: TreeNode[]) {
    this.data = schema;
  }
  @Output('onAddFilter') onAddFilter: EventEmitter<Filter> = new EventEmitter<Filter>();

  selectedFilters: Filter[] = [];
  data: TreeNode[] = [];
  options: Options = {
    floor: 0,
    ceil: 100,
    step: 10,
    showTicks: true
  };

  filterType = FilterType;
  nodeType = NodeType;
  logicaOperator = FilterLogicaOperator;
  comparisonOperator = FilterComparisonOperator;

  disableMedidaAltoAncho: boolean = false;
  disableMedidaSuperficie: boolean = false;

  showMedida(filter: Filter): boolean {
    const esAnchoAlto: boolean = filter.key === FilterKey.MEDIDA_ANCHURA || filter.key === FilterKey.MEDIDA_ALTURA;
    const esSuperficie: boolean  = filter.key === FilterKey.MEDIDA_SUPERFICIE || filter.key === FilterKey.MEDIDA_SUPERFICIE_INCHES;
    //console.log(this.disableMedidaAltoAncho)
    return !(this.disableMedidaAltoAncho && esAnchoAlto) || !(this.disableMedidaSuperficie && esSuperficie);
  }

  togglNodeExpand(node: TreeNode): void {
    this.data.filter(n => n.rowNumber !== node.rowNumber).map(n => n.expanded = false);
    node.expanded = !node.expanded;
  }

  toggleCheckbox(value: boolean, filter: Filter): void {
    if (value){
      this.store.dispatch(addSelectedFilter({ filter }));
      this.store.dispatch(togglShowSideFilter());
    }
    else this.store.dispatch(removeSelectedFilter({ filter }))
  }

  setFiltersTreeValue(selectedFiltersIds: string[]) {
		let tree: TreeNode[] = this.data;
		let check = (nodes: TreeNode[]) => {
      for(const node of nodes){
        if(node.type === NodeType.FILTER){
          const id: string = FilterIdExtractor(node.filter);
          const idx: number = selectedFiltersIds.findIndex(fid => fid === id);
          const isSelected: boolean = idx > -1;
          if(isSelected){
            if(node.filter.type === FilterType.CHECK_BOX || node.filter.type === FilterType.INLINE_CHECK_BOX){
              node.checked = true;
            }
          } else {
            if(node.filter.type === FilterType.CHECK_BOX || node.filter.type === FilterType.INLINE_CHECK_BOX){
              node.checked = false;
            }
          }
        } else if(node.type === NodeType.PARENT) {
          check(node.children)
        }
      }
		}

    check(tree);
	}

  emitValue(filter: Filter): void {
    if(filter.type === FilterType.RANGE) this.resolveFilterMedida(filter);
    this.store.dispatch(addSelectedFilter({ filter }))
  }

  resolveFilterMedida(filter: Filter): void {
    this.store.dispatch(removeSelectedFilter({ filter }))
    const key: string = filter.key.replace('min', '').replace('max', '');
    if(key === FilterKey.MEDIDA_ALTURA || key === FilterKey.MEDIDA_ANCHURA) {
      // Elimina meida superficie
      this.store.dispatch(removeSelectedFilter({ filter: <Filter>{
        key: FilterKey.MEDIDA_SUPERFICIE,
        comparator: FilterComparisonOperator.GREATER_OR_EQUAL_THAN,
        type: FilterType.RANGE
      }}))
      this.store.dispatch(removeSelectedFilter({ filter: <Filter>{
        key: FilterKey.MEDIDA_SUPERFICIE,
        comparator: FilterComparisonOperator.LESS_OR_EQUAL_THAN,
        type: FilterType.RANGE
      }}))
      this.store.dispatch(removeSelectedFilter({ filter: <Filter>{
        key: FilterKey.MEDIDA_SUPERFICIE_INCHES,
        comparator: FilterComparisonOperator.GREATER_OR_EQUAL_THAN,
        type: FilterType.RANGE
      }}))
      this.store.dispatch(removeSelectedFilter({ filter: <Filter>{
        key: FilterKey.MEDIDA_SUPERFICIE_INCHES,
        comparator: FilterComparisonOperator.LESS_OR_EQUAL_THAN,
        type: FilterType.RANGE
      }}))
    } else if(key === FilterKey.MEDIDA_SUPERFICIE || key === FilterKey.MEDIDA_SUPERFICIE_INCHES) {
      // Elimina medida altura
      this.store.dispatch(removeSelectedFilter({ filter: <Filter>{
        key: FilterKey.MEDIDA_ALTURA,
        comparator: FilterComparisonOperator.GREATER_OR_EQUAL_THAN,
        type: FilterType.RANGE
      }}))
      this.store.dispatch(removeSelectedFilter({ filter: <Filter>{
        key: FilterKey.MEDIDA_ALTURA,
        comparator: FilterComparisonOperator.LESS_OR_EQUAL_THAN,
        type: FilterType.RANGE
      }}))
      this.store.dispatch(removeSelectedFilter({ filter: <Filter>{
        key: FilterKey.MEDIDA_ALTURA_INCHES,
        comparator: FilterComparisonOperator.GREATER_OR_EQUAL_THAN,
        type: FilterType.RANGE
      }}))
      this.store.dispatch(removeSelectedFilter({ filter: <Filter>{
        key: FilterKey.MEDIDA_ALTURA_INCHES,
        comparator: FilterComparisonOperator.LESS_OR_EQUAL_THAN,
        type: FilterType.RANGE
      }}))
      // Elimina medida anchura
      this.store.dispatch(removeSelectedFilter({ filter: <Filter>{
        key: FilterKey.MEDIDA_ANCHURA,
        comparator: FilterComparisonOperator.GREATER_OR_EQUAL_THAN,
        type: FilterType.RANGE
      }}))
      this.store.dispatch(removeSelectedFilter({ filter: <Filter>{
        key: FilterKey.MEDIDA_ANCHURA,
        comparator: FilterComparisonOperator.LESS_OR_EQUAL_THAN,
        type: FilterType.RANGE
      }}))
      this.store.dispatch(removeSelectedFilter({ filter: <Filter>{
        key: FilterKey.MEDIDA_ANCHURA_INCHES,
        comparator: FilterComparisonOperator.GREATER_OR_EQUAL_THAN,
        type: FilterType.RANGE
      }}))
      this.store.dispatch(removeSelectedFilter({ filter: <Filter>{
        key: FilterKey.MEDIDA_ANCHURA_INCHES,
        comparator: FilterComparisonOperator.LESS_OR_EQUAL_THAN,
        type: FilterType.RANGE
      }}))
    }
  }

  ngOnInit(): void {
    this.store.select(selectedFiltersSelector).subscribe(filters =>
      this.setFiltersTreeValue(filters.map(f => FilterIdExtractor(f))))
  }

}
